import Link from '@medflex/components/stories/Link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import TitleBar from '@medflex/components/stories/TitleBar';
import Brand from '@medflex/components/stories/Brand';
import useUserProfile from '../hooks/useUserProfile';

const InactiveUserModule = () => {
  const { userProfile = {} } = useUserProfile();
  const { type } = userProfile;
  const { fullNameWithTitle } = userProfile.attributes;
  const { t } = useTranslation(type, { keyPrefix: 'InactiveUserModule' });

  const sections = t('sections', { returnObjects: true }) || [];

  if (!Array.isArray(sections)) return null;

  return (
    <div className="h-full flex flex-col min-h-0 relative" data-component="InactiveUserModule">
      <TitleBar buttonLeft={<Brand size="8" />} />
      <div className="p-8 flex flex-col overflow-y-auto">
        <div className="flex flex-col space-y-10 self-center" style={{ maxWidth: '427px' }}>
          <div>{t('intro', { user: fullNameWithTitle })}</div>

          {sections.map((section, index) => (
            <div className="space-y-4" key={`sections.${index}`}>
              <Trans defaults={section}>
                <a
                  className="text-blue-500 hover:text-blue-500"
                  href="mailto:service@medflex.de"
                  target="_blank"
                  rel="noreferrer"
                >
                  service@medflex.de
                </a>
              </Trans>
            </div>
          ))}

          <div className="space-y-4">
            <Trans t={t} i18nKey="outro" />
          </div>

          <Link
            kind="button:primary"
            href="mailto:service@medflex.de"
            target="_blank"
            rel="noreferrer"
          >
            {t('cta')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InactiveUserModule;
